// src/services/PaymentService.js
import axios from 'axios';

class PaymentService {
  constructor() {
    // Initialize with your API keys (in a real app, these would be environment variables)
    this.apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://api.your-backend.com';
  }

  /**
   * Process a credit card payment for an NFT
   * @param {Object} paymentDetails - Payment information
   * @param {Object} nftDetails - NFT being purchased
   * @returns {Promise} - Result of the payment operation
   */
  async processCardPayment(paymentDetails, nftDetails) {
    try {
      const response = await axios.post(`${this.apiBaseUrl}/payments/process`, {
        paymentMethod: 'credit_card',
        paymentDetails,
        nftDetails,
        timestamp: new Date().toISOString()
      });
      
      return response.data;
    } catch (error) {
      console.error('Payment processing error:', error);
      throw new Error(error.response?.data?.message || 'Payment processing failed');
    }
  }

  /**
   * Get the user's custodial wallet details
   * @param {string} userId - The user's ID
   * @returns {Promise} - Wallet information
   */
  async getUserWallet(userId) {
    try {
      const response = await axios.get(`${this.apiBaseUrl}/users/${userId}/wallet`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user wallet:', error);
      return null;
    }
  }

  /**
   * Get the user's NFT collection from their custodial wallet
   * @param {string} userId - The user's ID
   * @returns {Promise} - Array of NFTs owned by the user
   */
  async getUserCollection(userId) {
    try {
      const response = await axios.get(`${this.apiBaseUrl}/users/${userId}/collection`);
      return response.data.nfts;
    } catch (error) {
      console.error('Error fetching user collection:', error);
      return [];
    }
  }
}

export default new PaymentService();